import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchNotificationSettings } from '../../services/NotificationsService';
import { NotificationSettings, NotificationSettingsPatch } from '../../types/Notifications';

type Result = UseMutationResult<NotificationSettings, Error, NotificationSettingsPatch>;

function usePatchNotificationSettings(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchNotificationSettings, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['notification-settings'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchNotificationSettings;
